import { FormattedMessage, useIntl } from 'react-intl';
import { type ReactNode } from 'react';
import type { ButtonProps } from '@repo/design-system-kit';
// oxlint-disable-next-line no-duplicate-imports
import { Button } from '@repo/design-system-kit';
import { IconArrowLeftOutlined } from '@repo/monochrome-icons';
import styles from './back-button.module.css';

export function BackButton({ ...props }: Omit<ButtonProps, 'children'>): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <Button
      aria-label={formatMessage({ id: 'generic.back.cta' })}
      data-test-back-button
      type="button"
      variant="tertiary"
      {...props}
    >
      <IconArrowLeftOutlined className={styles.icon} />
      <FormattedMessage id="generic.back.cta" />
    </Button>
  );
}
